import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Tags {

    RESPONSE_CODE = 'responseCode';

    RESPONSE_MESSAGE = 'responseMsg';

    APPLICATION_TOKEN = 'VOA_APPLICATION_TOKEN';

    AUTHORIZATION = 'server-authorization';

    SERVER_APPLICATION_TOKEN = 'x-access-token';

    SERVER_APPLICATION_X_TOKEN = 'x-token';

    KEYCLOAK_TOKEN = 'KEYCLOAK_TOKEN';

    KEYCLOAK_REFRESH_TOKEN = 'KEYCLOAK_REFRESH_TOKEN';

    EMAIL_VERIFICATION_STATUS = 'EMAIL_VERIFICATION_STATUS';

    PROJECT_BUILD_DATE = 'PROJECT_BUILD_DATE';

    LOGGED_USER_ID = 'VOA_LOGGED_USER_ID';

    LOGGED_USER_NAME = 'VOA_LOGGED_USER_NAME';

}
